/**
 * Read More button used on Single Event page
 */

const ReadMore = ($) => {
	// text to display based on locale

	const readMoreText = "See more";
	const readLessText = "See less";

	// paragraphs in event content description
	const children = $("#js-read-more-paragraphs").children().not("button");

	// all paragraphs after first 1
	const hiddenParagraphs = children.slice(1);

	// read more button, hidden by default
	const readMoreButton = $("#read-more-button");

	// hide paragraphs on page load, show button
	if (children.length > 1) {
		hiddenParagraphs.hide();
		readMoreButton.show();
	}

	$("#read-more-button").on("keydown mousedown", (e) => {
		$(e.target).blur()
		// toggle paragraphs
		if ($(hiddenParagraphs).is(":visible")) {
			hiddenParagraphs.slideUp();
			$(e.target).text(readMoreText);
			$(e.target).removeClass("read-less-button");
		} else {
			hiddenParagraphs.slideDown();
			$(e.target).text(readLessText);
			$(e.target).addClass("read-less-button");
		}
	});

	$("#read-more-button").on("mouseup", (e) => $(e.target).blur());
};

export default ReadMore;
